import { CustomFieldScope } from "../AppGlobals";
import { BaseCustomFieldDfns, IBaseCustomFieldDfns } from "./BaseCustomFieldDfns";


export interface ICustomFieldDfn extends IBaseCustomFieldDfns {
    Scope?: CustomFieldScope | null;
    DataType?: string;
    ListValues?: string;
    Display: boolean;
}

export class CustomFieldDfn extends BaseCustomFieldDfns implements ICustomFieldDfn {    
    public Scope = null;
    public DataType = null;
    public ListValues = null;
    public Display = false;
}
